(function () {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function download(url, fileName) {
      if (!url) return;
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'WebAlarm-Overview.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    function close(modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (modal._lastFocus) modal._lastFocus.focus();
    }

    function open(modal) {
      modal._lastFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const field = modal.querySelector('[name="company"], [data-cf-deck-success]');
      if (field && field.focus) field.focus();
    }

    function bind(modal) {
      if (modal.dataset.cfDeckBound === 'true') return;
      modal.dataset.cfDeckBound = 'true';
      const form = modal.querySelector('form');
      modal.querySelector('[data-cf-deck-close]')?.addEventListener('click', () => close(modal));
      modal.addEventListener('click', (event) => {
        if (event.target === modal) close(modal);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) close(modal);
      });
      document.querySelectorAll('[data-cf-deck-open]').forEach((trigger) => {
        if (trigger.dataset.cfDeckOpenBound === 'true') return;
        if (trigger.dataset.cfDeckOpen && trigger.dataset.cfDeckOpen !== modal.id) return;
        trigger.dataset.cfDeckOpenBound = 'true';
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          open(modal);
        });
      });
      const success = modal.querySelector('[data-cf-deck-success]');
      const postedHash = window.location.hash.slice(1);
      if (success && (!postedHash || !form || postedHash === form.id)) {
        open(modal);
        download(success.dataset.deckUrl || modal.dataset.deckUrl, modal.dataset.deckFile);
      }
      if (modal.querySelector('.cf-deck__form-error')) open(modal);
      form?.addEventListener('input', (event) => {
        event.target.closest('.is-error')?.classList.remove('is-error');
      });
      form?.addEventListener('submit', (event) => {
        const company = form.querySelector('[name="company"]');
        const email = form.querySelector('[name="contact[email]"]');
        const name = form.querySelector('[name="contact[first_name]"]');
        const consent = form.querySelector('[name="contact[accepts_marketing]"]');
        const note = form.querySelector('[data-cf-deck-note]');
        const companyBad = !company || !company.value.trim();
        const emailBad = !email || !emailPattern.test(email.value.trim());
        const consentBad = !consent || !consent.checked;
        company?.closest('[data-cf-field]')?.classList.toggle('is-error', companyBad);
        email?.closest('[data-cf-field]')?.classList.toggle('is-error', emailBad);
        consent?.closest('[data-cf-field]')?.classList.toggle('is-error', consentBad);
        if (companyBad || emailBad || consentBad) {
          event.preventDefault();
          modal.querySelector('.is-error input')?.focus();
          return;
        }
        if (note) {
          const who = name && name.value.trim() ? name.value.trim() : 'Not given';
          note.value = 'Company: ' + company.value.trim() + '\nName: ' + who + '\nSource: ' + (modal.dataset.deckSource || 'webalarm-deck');
        }
      });
    }

    function scan() {
      document.querySelectorAll('[data-cf-deck]').forEach(bind);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();
